import {Component, DoCheck, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {SortTableCellTitleSharingInfo} from '../../../../../shared/models/sort-table/cell-classes';
import {SessionService} from '../../../../../core/services/session.service';
import {UserId} from '../../../../../shared/models/user';
import {AlarmsService} from '../../../../../core/services/alarms.service';
import {AlarmEvent} from '../../../../../shared/models/alarm';
import {OptionGroup} from '../../../../../shared/models/option';
import {makeAlarmMenuOptions} from '../../../../../shared/utils/alarm.util';
import {TileAlarmBadgeComponent} from '../../../tile/alarm-badge/tile-alarm-badge.component';
import {isEmptyId} from '../../../../../shared/constants/empty-id';
import {ShareButtonComponent} from '../../../share-button/share-button.component';
import {UserLinkComponent} from '../../../user-link/user-link.component';

@Component({
  selector: 'motn-sort-table-cell-title-sharing-info',
  template: `
    <div class="title">
      <span [innerText]="cell.title"></span>
      @if (cell.alarmEvent; as alarmEvent) {
        <motn-tile-alarm-badge
          [alarmEvent]="alarmEvent"
          [alarmMenuOptions]="alarmMenuOptions"
          (click)="openAlarmMenu(alarmEvent)"
          (clickedAfterRender)="alarmMenuOptions = null"
        ></motn-tile-alarm-badge>
      }
    </div>
    @if (cell.displayName) {
      <div class="display-name" [innerText]="cell.displayName"></div>
    }
    @if (cell.facetTags?.length) {
      <div class="facets-row">
        @for (facet of cell.facetTags; track facet.ID) {
          @if (!$first) {<i class="fa-solid fa-circle-dot facet-inline-sep"></i>}
          <span class="facet-inline" [title]="facet.Value">{{ facet.Value }}</span>
        }
      </div>
    }
    <div
      class="description"
    >
      <motn-share-button
        [object]="cell.object"
      ></motn-share-button>

      @if (showOwner) {
        <div>
          Owned by
          <motn-user-link
            [userId]="cell.object.owner"
          ></motn-user-link>
        </div>
      }
    </div>
  `,
  styleUrls: ['./sort-table-cell-title-sharing-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ShareButtonComponent,
    UserLinkComponent,
    TileAlarmBadgeComponent,
  ],
})
export class SortTableCellTitleSharingInfoComponent extends BaseCellComponent implements OnInit, DoCheck {
  @Input() cell: SortTableCellTitleSharingInfo;

  currentUserId: UserId;
  alarmMenuOptions: OptionGroup | null = null;

  constructor(
    private session: SessionService,
    private alarmsService: AlarmsService,
  ) {
    super();
  }

  get showOwner(): boolean {
    const owner = this.cell?.object?.owner;
    return !isEmptyId(owner) && owner !== this.currentUserId;
  }

  ngDoCheck(): void {
    if (!this.cell?.alarmEvent) {
      this.alarmMenuOptions = null;
    }
  }

  openAlarmMenu(alarmEvent: AlarmEvent): void {
    this.alarmMenuOptions = makeAlarmMenuOptions(alarmEvent, this.alarmsService);
  }

  protected onInit(): void {
    this.currentUserId = this.session.userId;
  }
}
